import { render } from "./ShowSimpleUnit.vue?vue&type=template&id=edf7f7f6&scoped=true&ts=true"
import script from "./ShowSimpleUnit.vue?vue&type=script&lang=ts"
export * from "./ShowSimpleUnit.vue?vue&type=script&lang=ts"

import "./ShowSimpleUnit.vue?vue&type=style&index=0&id=edf7f7f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edf7f7f6"]])

export default __exports__